import * as React from "react";
import { useModal } from "../../../../utils/custom-hooks";
import { RBACHidden } from "../../../helpers/rbac/rbac";
import { useAuthContextV2 } from "../../../../auth-state";
import { ProceduresContextProps } from "../../../../application/service/smart-apply/procedures/procedures-service";
import {
  ContentsHeader,
  KebabMenu,
  MenuItemProps,
  PrimaryButton,
} from "@graffer-inc/console-design-kit";
import { ProceduresSearchWindow } from "../../../organisms/smart-apply/procedure-list/procedures-search-window";

export const ProceduresListHeader: React.FC<
  Pick<ProceduresContextProps, "queryName" | "setName" | "searchProcedures"> & {
    importProcedureModal: ReturnType<typeof useModal>;
    procedureModal: ReturnType<typeof useModal>;
    menuToggle: ReturnType<typeof useModal>;
    updateProcedureGroupModal: ReturnType<typeof useModal>;
  }
> = ({
  queryName,
  setName,
  searchProcedures,
  importProcedureModal,
  procedureModal,
  menuToggle,
  updateProcedureGroupModal,
}) => {
  const authState = useAuthContextV2();
  const menuItems: MenuItemProps[] = [];

  if (authState.auth.hasPermissions("procedures.create")) {
    menuItems.push({
      text: "手続きをインポート",
      anchor: ({ children, ...props }) => (
        <button onClick={importProcedureModal.open} {...props}>
          {children}
        </button>
      ),
      active: menuToggle.isActive,
    });
  }
  if (authState.auth.hasPermissions("procedures.manage_group_bulk_update")) {
    menuItems.push({
      text: "管理グループ一括更新",
      anchor: ({ children, ...props }) => (
        <button onClick={updateProcedureGroupModal.open} {...props}>
          {children}
        </button>
      ),
      active: menuToggle.isActive,
    });
  }

  return (
    <ContentsHeader
      title="手続き一覧"
      captionDirection="row"
      border={false}
      caption={[
        <ProceduresSearchWindow
          key={"proceduresSearchWindow"}
          searchName={queryName}
          setSearchName={setName}
          searchProcedures={searchProcedures}
        />,
      ]}
      buttons={[
        [
          <RBACHidden
            key={"proceduresRBACHidden"}
            requirePermissions={"procedures.create"}
          >
            <p className="level-item">
              <PrimaryButton
                text={"新規手続き作成"}
                onClick={procedureModal.open}
                icon={"PlusCircleIcon"}
              />
            </p>
          </RBACHidden>,
          menuItems.length !== 0 ? (
            <KebabMenu
              items={[
                {
                  title: "編集",
                  menuItems: menuItems,
                },
              ]}
            />
          ) : undefined,
        ],
      ]}
    />
  );
};
